"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { ApiError, api, errorMessage } from "@/lib/api-client";
import { Button } from "@/components/ui/button";
import { Field, Input } from "@/components/ui/field";
import { Alert } from "@/components/ui/alert";

export function SignupForm() {
  const router = useRouter();
  const [form, setForm] = useState({ name: "", email: "", password: "", organizationName: "" });
  const [error, setError] = useState<ApiError | Error | null>(null);
  const [loading, setLoading] = useState(false);
  const set = (k: keyof typeof form) => (e: React.ChangeEvent<HTMLInputElement>) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const fieldErr = (k: string) => (error instanceof ApiError ? error.fieldError(k) : undefined);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (form.password.length < 10) {
      setError(new Error("Password must be at least 10 characters."));
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await api.post("/auth/signup", form);
      router.push("/app");
      router.refresh();
    } catch (err) {
      setError(err instanceof Error ? err : new Error(errorMessage(err)));
      setLoading(false);
    }
  }

  return (
    <form onSubmit={submit} className="mt-8 space-y-4">
      {error ? <Alert tone="critical">{error.message}</Alert> : null}
      <Field label="Your name" htmlFor="name" error={fieldErr("name")}>
        <Input id="name" autoComplete="name" required value={form.name} onChange={set("name")} />
      </Field>
      <Field label="Work email" htmlFor="email" error={fieldErr("email")}>
        <Input id="email" type="email" autoComplete="email" required value={form.email} onChange={set("email")} />
      </Field>
      <Field label="Password" htmlFor="password" hint="At least 10 characters." error={fieldErr("password")}>
        <Input id="password" type="password" autoComplete="new-password" required minLength={10} value={form.password} onChange={set("password")} />
      </Field>
      <Field label="Organisation name" htmlFor="org" error={fieldErr("organizationName")}>
        <Input id="org" autoComplete="organization" required value={form.organizationName} onChange={set("organizationName")} />
      </Field>
      <Button type="submit" className="w-full" loading={loading}>
        Create workspace
      </Button>
      <p className="text-xs text-ink-muted">You&apos;ll be the owner of the new organisation and can invite your team afterwards.</p>
    </form>
  );
}
